module.exports = __webpack_public_path__ + "media/images/wedding/18-22034f2f1dbc013dda20f5cc0f4486a2.jpg";